import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { useEffect, useRef } from 'react';

export const useToggleStickyCarousel = (
    scrollBarContainerRef: React.RefObject<HTMLDivElement>,
    pageType?: 'TTD' | 'POI',
) => {
    const STICKY_POSITION = useRef(0);

    useEffect(() => {
        if (HAS_WINDOW) {
            const calculateStickyPosition = () => {
                STICKY_POSITION.current =
                    window.scrollY +
                    (scrollBarContainerRef.current?.getBoundingClientRect()
                        ?.top ?? 0);
            };
            calculateStickyPosition();

            const toggleStickyCarousel = () => {
                if (scrollBarContainerRef.current) {
                    let WINDOW_OFFSET = window.innerWidth > 834 ? 24 : 0;
                    WINDOW_OFFSET -= pageType === 'TTD' ? 36 : 0;

                    if (
                        window.scrollY >=
                        STICKY_POSITION.current - WINDOW_OFFSET
                    ) {
                        scrollBarContainerRef.current.classList.add('sticky');
                    } else {
                        scrollBarContainerRef.current.classList.remove(
                            'sticky',
                        );
                    }
                }
            };

            window.addEventListener('scroll', toggleStickyCarousel);
            window.addEventListener('resize', calculateStickyPosition);

            return () => {
                window.removeEventListener('scroll', toggleStickyCarousel);
                window.addEventListener('resize', calculateStickyPosition);
            };
        }
        // Only run this on initial page load
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
